import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormControl, FormLabel, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';

interface DonationAmountFieldsProps {
  control: Control<any>;
  minAmount: number;
  maxAmount: number;
}

export const DonationAmountFields: React.FC<DonationAmountFieldsProps> = ({
  control,
  minAmount,
  maxAmount,
}) => {
  return (
    <div>
      <FormLabel component="legend" sx={{ mb: 2.5 }}>
        Donation Amount
      </FormLabel>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
        }}
      >
        <FormControl style={{ width: '100%' }}>
          <Controller
            name="minAmount"
            control={control}
            rules={{
              required: 'Minimum amount is required',
              min: {
                value: 0,
                message: 'Minimum amount cannot be negative',
              },
              validate: (value) => {
                const numValue = Number(value);
                const numMaxAmount = Number(maxAmount);
                if (numMaxAmount && numValue >= numMaxAmount) {
                  return 'Minimum amount must be less than maximum amount';
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => (
              <>
                <InputLabel htmlFor="minAmount">Min Amount *</InputLabel>
                <OutlinedInput
                  id="minAmount"
                  {...field}
                  label="Min Amount *"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  type="number"
                  inputProps={{ min: 0 }}
                  required
                  error={Boolean(fieldState.error)}
                />
                {fieldState.error && (
                  <div style={{ color: 'red', fontSize: '0.75rem', marginTop: '4px' }}>
                    {fieldState.error.message}
                  </div>
                )}
              </>
            )}
          />
        </FormControl>
        <FormControl style={{ width: '100%' }}>
          <Controller
            name="maxAmount"
            control={control}
            rules={{
              required: 'Maximum amount is required',
              min: {
                value: 0,
                message: 'Maximum amount cannot be negative',
              },
              validate: (value) => {
                const numValue = Number(value);
                const numMinAmount = Number(minAmount);
                if (numMinAmount && numValue <= numMinAmount) {
                  return 'Maximum amount must be greater than minimum amount';
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => (
              <>
                <InputLabel htmlFor="maxAmount">Max Amount *</InputLabel>
                <OutlinedInput
                  id="maxAmount"
                  {...field}
                  label="Max Amount *"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  type="number"
                  inputProps={{ min: 0 }}
                  required
                  error={Boolean(fieldState.error)}
                />
                {fieldState.error && (
                  <div style={{ color: 'red', fontSize: '0.75rem', marginTop: '4px' }}>
                    {fieldState.error.message}
                  </div>
                )}
              </>
            )}
          />
        </FormControl>
      </div>
    </div>
  );
};
